<template>
  <require from="framework/html_behaviors/af-popover"></require>
  <require from="framework/value_converters/date-and-time"></require>

  <div class="event-box leaflet-bar user-location-request" style="min-width: 200px;">
    <div class="event-box-summary d-flex ${ data.hasLocation ? '--has-location' : '' }" click.delegate="showUserLocation()">
      <div class="event-box-icon">
        <i class="far fa-dot-circle"></i>
      </div>
      <div class="event-box-content">
        <div class="d-flex justify-content-between">
          <span class="mr-3">Location Request</span><span class="user-location-request-status --status-${ data.state.value }"><i></i> ${data.state.name}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span class="font-weight-bold mr-3">${data.userName}</span><span>${data.requestedOn | dateTime:'DD/MM/YY HH:mm'}</span>
        </div>
      </div>
    </div>
  </div>
</template>
